// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let MenuV5 = require("../../../common/Components/menu/MenuV5.bs.js");
let Scalars = require("../../../../scalars/Scalars.bs.js");
let UTCDate = require("../../../../reason/common/types/UTCDate.bs.js");
let ViewStack = require("../../../../reason/common/ViewStack.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let DuplicatePropertyError = require("./DuplicatePropertyError.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyAddressValidationCallout = require("./PropertyAddressValidationCallout.bs.js");
let DuplicateBroadcastForSalePropertyError_editableBroadcastForSaleProperty_graphql = require("../../../../__generated__/DuplicateBroadcastForSalePropertyError_editableBroadcastForSaleProperty_graphql.bs.js");

let convertFragment = DuplicateBroadcastForSalePropertyError_editableBroadcastForSaleProperty_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, DuplicateBroadcastForSalePropertyError_editableBroadcastForSaleProperty_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(DuplicateBroadcastForSalePropertyError_editableBroadcastForSaleProperty_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, DuplicateBroadcastForSalePropertyError_editableBroadcastForSaleProperty_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(DuplicateBroadcastForSalePropertyError_editableBroadcastForSaleProperty_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function DuplicateBroadcastForSalePropertyError(props) {
  let property = RescriptRelay_Fragment.useFragment(DuplicateBroadcastForSalePropertyError_editableBroadcastForSaleProperty_graphql.node, convertFragment, props.property);
  return JsxRuntime.jsxs(PropertyAddressValidationCallout.make, {
    heading: "You already have a property with this address on TAN",
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("p", {
          children: [
            "You have already added a broadcast property at ",
            JsxRuntime.jsx("strong", {
              children: property.address + `, ` + property.area.label
            }),
            ` to TAN ` + UTCDate.formatDistanceFromNow(true, Scalars.DateTime.toUTC(property.createdAt)) + ` ago. `,
            "Click below to view, edit, or rebroadcast it"
          ]
        }),
        className: "leading-normal"
      }),
      JsxRuntime.jsxs(ViewStack.make, {
        pt: "sm",
        space: "sm",
        justifyContent: "flexEnd",
        flexDirection: "row",
        children: [
          JsxRuntime.jsx(DuplicatePropertyError.ViewClientButton.make, {
            clientId: property.client.id
          }),
          JsxRuntime.jsxs(DuplicatePropertyError.ActionsDropdown.make, {
            children: [
              JsxRuntime.jsx(MenuV5.MenuItem.make, {
                href: `/properties/` + property.id + `/edit`,
                children: "Edit Broadcast Property"
              }),
              JsxRuntime.jsx(MenuV5.MenuItem.make, {
                href: `/properties/` + property.id + `/broadcast`,
                children: "Rebroadcast Property"
              })
            ]
          })
        ]
      })
    ],
    icon: "Warning"
  });
}

let make = DuplicateBroadcastForSalePropertyError;

exports.Fragment = Fragment;
exports.make = make;
/* MenuV5 Not a pure module */
